import { useCallback, useEffect, useContext, useState, useMemo, Suspense, useRef } from "react";
import { Paper, Grid, Checkbox } from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { AuthContext, PaycheckContext, ThemeContext } from "../../../../../../../../contexts";
import EventNoteIcon from "@material-ui/icons/EventNote";
import { useLocation, useNavigate } from "react-router-dom";
import {
	ApproveEnrollmentPayload,
	ApproveHOOEnrollmentPayload
} from "../../../../../../../../utils/api/enrollment/enrollment";
import "./gstdForm.css";
import { Member } from "../../../../../../../../@types/member.types";
import { numberToDollarStr } from "../../../../../../../../utils/commonFunctions/dollar";
import { Plan, PremiumRateCoverage } from "../../../../../../../../@types/plan.types";

import { Validation } from "../../../../../../../../@types/validation.types";
import { CoverageDetails } from "../../../../../../../shared/enrollment";
import { CustomInput } from "../../../../../../../shared/customInput";
import {
	dateFormateToMonthDayYear,
	dateTimeZoneConverter,
	getCurrentDate
} from "../../../../../../../../utils/commonFunctions/date";
import useRouteParam from "../../../../../../../../hooks/useRouteParam";
import { ApproveEnrollment } from "../../../../../../../../@types/components/enrollmentProps.types";
import { CommonDetails, Enrollment } from "../../../../../../../../@types/enrollment.types";
import { AdminEnrollmentInitDataQuery } from "../../../../../../../../utils/api/pages/enrollmentInit";
import { trackPromise } from "react-promise-tracker";
import { getCommonDetails } from "../../../../../../../../utils/commonFunctions/groupEnrollment/enrollmentPayload";
import { api } from "../../../../../../../../utils/api";
import PlanHeader from "../../../../../../../shared/enrollment/planCode/PlanHeader";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { LazyApproveEnrollment } from "../../../../../..";
import Button from "@material-ui/core/Button/Button";
import SendIcon from "@material-ui/icons/Send";
import encryption from "../../../../../../../../utils/commonFunctions/encryption";
import { ENROLLMENT_STATUS } from "../../../../../../../../constants/enrollment/enrollmentStatus";

const GstdForm = (): JSX.Element => {
	const [member, setMember] = useState<Member>();
	const [enrollments, setEnrollments] = useState<Enrollment[]>([]);
	const { paycheck, setPaycheck } = useContext(PaycheckContext);
	const [coverageDetails, setCoverageDetails] = useState<any[]>([]);
	const { theme, setTheme } = useContext(ThemeContext);
	const queryPlanCode = useRouteParam("pc");
	const queryGroupNumber = useRouteParam("gn");
	const querySSN = useRouteParam("qs");
	const navigate = useNavigate();
	const location = useLocation();
	const [plan, setPlan] = useState<Plan>();
	const [validation, setValidation] = useState<Validation>({
		approvedEnrollment: {},
		status: "invalid"
	});
	const [approveEnrollment, setApproveEnrollment] = useState<ApproveEnrollment>();
	const [enrollmentDate, setEnrollmentDate] = useState("");
	const [enrollmentCommonDetail, setEnrollmentCommonDetail] = useState<CommonDetails>();
	const [premiumAmount, setPremiumAmount] = useState<null | number>(null);
	const _validation = useRef<Validation>();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	const handleApproveEnrollmentChange = useCallback(
		(
			event: React.ChangeEvent<
				| HTMLInputElement
				| {
						name?: string | undefined;
						value: unknown;
				  }
			>,
			child?: React.ReactNode
		) => {
			const { name, value } = event.target;
			// console.log(value);
			setApproveEnrollment(
				Object.assign({}, approveEnrollment, {
					[name as string]: value
				})
			);
		},
		[approveEnrollment]
	);

	const handleValidation = useCallback(async () => {
		_validation.current = {
			...validation,
			approveEnrollment: {},
			status: "invalid"
		};
		let flag = true;

		if (approveEnrollment === undefined) {
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (!approveEnrollment?.enrollment_status || approveEnrollment?.enrollment_status === "SUBMITTED") {
			_validation.current.approveEnrollment["enrollment_status"] = "Enrollment Status is required";
			_validation.current.status = "invalid";
			flag = false;
		}

		if (approveEnrollment?.enrollment_status === "ACTIVE" && approveEnrollment?.effective_date === null) {
			_validation.current.approveEnrollment["effective_date"] =
				"For active enrollment effective date is required";
			_validation.current.status = "invalid";
			flag = false;
		}

		if (flag === true) _validation.current["status"] = "valid";
		else {
			_validation.current["status"] = "invalid";
			// alert("Please, fill effective date field !");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current.status;
	}, [approveEnrollment, validation]);

	// const handleApproveEnrollmentDateChange = useCallback(
	// 	(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
	// 		const selectedDate = new Date(date as any);

	// 		const parsedDate =
	// 			selectedDate.getFullYear() + "-" + (selectedDate.getMonth() + 1) + "-" + selectedDate.getDate();

	// 		setApproveEnrollment(
	// 			Object.assign({}, approveEnrollment, {
	// 				effective_date: parsedDate
	// 			})
	// 		);
	// 	},
	// 	[approveEnrollment]
	// );

	const handleApproveEnrollmentDateChange = useCallback(
		(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
			const parsedDate = date as unknown as string;
			setApproveEnrollment(Object.assign({}, approveEnrollment, { effective_date: parsedDate }));
		},
		[approveEnrollment]
	);

	const handleMemberDetailsRedirection = useCallback(() => {
		const pathname = `/employer/member?gn=${queryGroupNumber}&&qs=${
			encryption(querySSN as string) as string
		}&&to=benefits`;
		navigate(pathname);
	}, [navigate, queryGroupNumber, querySSN]);

	const handleSubmitEnrollmentClick = useCallback(
		async (event: React.FormEvent<HTMLButtonElement>) => {
			// console.log("approve", approveEnrollment);
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const validation = await handleValidation();
			if (validation === "valid") {
				if (approveEnrollment === undefined || enrollmentCommonDetail === undefined) {
					return;
				}

				const { effective_date } = approveEnrollment;

				const effectiveDate = new Date(effective_date as unknown as Date);

				const _approveEnrollmentPayload = {
					...approveEnrollment,
					effective_date:
						effectiveDate.getFullYear() +
						"-" +
						(effectiveDate.getMonth() + 1) +
						"-" +
						effectiveDate.getDate()
				};

				const approveEnrollmentPayload: ApproveEnrollmentPayload = {
					..._approveEnrollmentPayload,
					common_detail: enrollmentCommonDetail,
					dependent_standard_details: [],
					covered_dependent_SSNs: []
				};
				const response = await trackPromise(api.enrollments.approveEnrollment(approveEnrollmentPayload));
				if (response) {
					const { enrollment_status } = response.result;

					enrollment_status === ENROLLMENT_STATUS.active
						? alert("Group Short Term Disability Approval Submitted!")
						: enrollment_status === ENROLLMENT_STATUS.rejected
						? alert("Group Short Term Disability Approval has been Rejected!")
						: alert(null);
					// Redirection to Member Family Details
					handleMemberDetailsRedirection();
				}
			}
		},
		[approveEnrollment, enrollmentCommonDetail, handleMemberDetailsRedirection, handleValidation]
	);

	const getPremiumAmount = useCallback(
		(premiumRateCoverage: PremiumRateCoverage): string => {
			let premiumAmount = "";
			if (paycheck) {
				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount =
						(paycheck.pay_frequency === "WEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = `${numberToDollarStr(Number(premiumAmount))}`;
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount =
						(paycheck.pay_frequency === "WEEKLY"
							? premiumRateCoverage.weekly_premium
							: premiumRateCoverage.monthly_premium) + "";
					premiumAmount = premiumAmount + "%";
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getPremiumRateByFixed = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = coverageCode.monthly_premium as number;
			} else if (paycheck.pay_frequency === "WEEKLY") {
				premiumAmount = coverageCode.weekly_premium as number;
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getPremiumRateByPercentage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			if (paycheck.pay_frequency === "MONTHLY") {
				premiumAmount = (basePayRate * ((coverageCode.monthly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.monthly_maximum_premium as number)) {
					premiumAmount = coverageCode.monthly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.monthly_minimum_premium as number)) {
					premiumAmount = coverageCode.monthly_minimum_premium as number;
				}
			} else if (paycheck.pay_frequency === "WEEKLY") {
				premiumAmount = (basePayRate * ((coverageCode.weekly_premium as number) / 100)) as number;
				if (premiumAmount > (coverageCode.weekly_maximum_premium as number)) {
					premiumAmount = coverageCode.weekly_maximum_premium as number;
				} else if (premiumAmount < (coverageCode.weekly_minimum_premium as number)) {
					premiumAmount = coverageCode.weekly_minimum_premium as number;
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const calculatePremiumByCoverage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage): number | null => {
			if (paycheck === null) {
				return null;
			}

			let premiumAmount: number | null;
			if (coverageCode.active === false) {
				alert("Member is not covered in this plan");
				return null;
			}
			if (coverageCode.premium_type === "PERCENTAGE") {
				premiumAmount = getPremiumRateByPercentage(basePayRate, coverageCode);
			} else if (coverageCode.premium_type === "FIXED") {
				premiumAmount = getPremiumRateByFixed(basePayRate, coverageCode);
			} else {
				alert("Invalid premium type");
				return null;
			}
			return premiumAmount;
		},
		[getPremiumRateByFixed, getPremiumRateByPercentage, paycheck]
	);

	const getCoverageDetails = useCallback(() => {
		const _coverageDetails: any[] = [];

		if (plan === undefined) {
			return;
		}
		const { coverage } = plan;
		if (coverage.EE.active === true) {
			const premiumAmount = getPremiumAmount(coverage.EE);

			_coverageDetails.push({
				coverage: "Employee Only",
				premiumAmount
			});
		}
		if (coverage.ES.active === true) {
			const premiumAmount = getPremiumAmount(coverage.ES);
			_coverageDetails.push({
				coverage: "Coverage For Spouse",
				premiumAmount
			});
		}
		if (coverage.EC.active === true) {
			const premiumAmount = getPremiumAmount(coverage.EC);
			_coverageDetails.push({
				coverage: "Coverage For One Child",
				premiumAmount
			});
		}
		if (coverage.ECH.active === true) {
			const premiumAmount = getPremiumAmount(coverage.ECH);
			_coverageDetails.push({
				coverage: "Coverage For Two or More Children",
				premiumAmount
			});
		}
		setCoverageDetails(Object.assign([], _coverageDetails));
	}, [getPremiumAmount, plan]);

	const getAdminEnrollmentInitData = useCallback(async () => {
		if (!queryGroupNumber || !queryPlanCode || !querySSN) {
			return;
		}

		const query: AdminEnrollmentInitDataQuery = {
			insured_SSN: querySSN as string,
			plan_code: queryPlanCode as string,
			group_number: queryGroupNumber as number
		};
		const { theme, enrollments, paycheck } = await trackPromise(api.pages.getAdminEnrollmentInitData(query));
		setEnrollments(Object.assign([], enrollments));
		setPlan(Object.assign({}, enrollments[0].plan));
		setTheme(Object.assign({}, theme));
		setPaycheck(Object.assign({}, paycheck));
		setPremiumAmount(enrollments[0].premium_amount);
		setMember(Object.assign({}, enrollments[0].employee));
		setApproveEnrollment((prevApproveEnrollment: ApproveEnrollment | undefined) =>
			Object.assign({}, prevApproveEnrollment, {
				_id: enrollments[0]._id,
				plan_code: enrollments[0].plan_code,
				insured_SSN: enrollments[0].insured_SSN,
				current_paycheck_id: paycheck._id,
				enrollment_status: enrollments[0].enrollment_status,
				effective_date: enrollments[0].effective_date
			})
		);
		setEnrollmentCommonDetail(getCommonDetails(enrollments[0]));
		setEnrollmentDate(enrollments[0].enrollment_date as unknown as string);
	}, [queryGroupNumber, queryPlanCode, querySSN, setPaycheck, setTheme]);

	useEffect(() => {
		getAdminEnrollmentInitData();
	}, [getAdminEnrollmentInitData]);

	useEffect(() => {
		getCoverageDetails();
	}, [getCoverageDetails]);

	if (plan === undefined) {
		return <></>;
	}

	return (
		<div className="GSTD theme-container">
			<Paper className="paper-container">
				<PlanHeader planCode={plan?.plan_code} planName="Group Short Term Disability" />
				<div className="theme-plan-section-margin" />
				<div className="external-links">
					<div>
						<LinkIcon className="link-icon" style={{ color: theme.primary_color }} />
					</div>
					<div className="header">
						Click on the following links to know more about <strong>Class 1</strong> and{" "}
						<strong>Class 2</strong> benefits
					</div>
				</div>
				<div className="theme-plan-inner-section-margin" />
				<div className="link-container">
					<div className="theme-plan-icon-item-center-container">
						<div>
							<FiberManualRecordIcon className="theme-plan-subpoint-icon" />
						</div>
						<div className="theme-plan-subpoint-text">
							<a href="#">Class 1 Benefits</a> - Full-Time Employees other than truck drivers
						</div>
					</div>
					<div className="theme-plan-sub-inner-section-margin" />
					<div className="theme-plan-icon-item-center-container">
						<div>
							<FiberManualRecordIcon className="theme-plan-subpoint-icon" />
						</div>
						<div className="theme-plan-subpoint-text">
							<a href="#">Class 2 Benefits</a> - Full-Time truck drivers
						</div>
					</div>
				</div>
				<div className="theme-plan-section-margin" />
				<CoverageDetails coverageDetails={coverageDetails} />
				<div className="theme-plan-section-margin" />
				<div className="theme-plan-icon-item-container">
					<div>
						<EventNoteIcon className="event-icon" style={{ color: theme.primary_color }} />
					</div>
					<div className="theme-plan-text">
						<strong>Note:</strong> Participants should refer to the summary plan description for the
						Cafeteria Plan for additional status change and election change events
					</div>
				</div>
				<div style={{ marginTop: "4rem" }} />
				<div>
					<div className="details-form-row">
						<div className="details-form-label  required">Premium Amount</div>
						<CustomInput value={`$ ${premiumAmount}`} disabled />
					</div>
				</div>
				<div className="theme-plan-section-margin" />
				<div className="option-content">
					<Checkbox defaultChecked style={{ paddingLeft: 0 }} />
					<p className="checkbox-label">
						<strong>
							I UNDERSTAND AND AGREE TO THE TERMS AND CONDITIONS STATED ABOVE AND AUTHORIZE
							THE&nbsp;PAYROLL DEDUCTIONS TO BE MADE AS INDICATED
						</strong>
					</p>
				</div>
				<div className="theme-plan-section-margin" />
				<Grid container>
					<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
						<div className="details-form-row">
							<div className="details-form-label  required">Signature</div>
							<CustomInput value={member?.first_name + " " + member?.last_name} disabled />
						</div>
					</Grid>
					<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
						<div className="details-form-row">
							<div className="details-form-label  required">Date</div>
							<CustomInput
								value={
									dateTimeZoneConverter(
										approveEnrollment ? dateFormateToMonthDayYear(enrollmentDate) : getCurrentDate()
									) as string
								}
								disabled
							/>
						</div>
					</Grid>
				</Grid>
				<div className="theme-plan-section-margin" />
				<div
					className="theme-divider-grad-mask"
					style={{
						background: `linear-gradient(90deg, ${theme.primary_color} 0 55%, transparent 0 100%) 0 0 / 2rem 1rem`
					}}
				/>
				{approveEnrollment ? (
					<>
						<Suspense fallback={<div />}>
							<LazyApproveEnrollment
								enrollmentDate={enrollmentDate}
								approveEnrollment={approveEnrollment}
								handleApproveEnrollmentChange={handleApproveEnrollmentChange}
								handleApproveEnrollmentDateChange={handleApproveEnrollmentDateChange}
								validation={validation}
							/>
						</Suspense>
						<div className="theme-plan-section-margin" />
						<div className="enrollment-submit-button-container" id="enrollment-submit-button-container">
							<Button
								className="button-green"
								onClick={handleSubmitEnrollmentClick}
								variant="contained"
								style={{
									pointerEvents: "unset"
								}}
							>
								<span className="button-label-with-icon">Submit</span>
								<span>
									<SendIcon className="button-icon" />
								</span>
							</Button>
						</div>
					</>
				) : null}
			</Paper>
		</div>
	);
};

export default GstdForm;
